"use client"

import * as React from "react"
import { cn } from "@/lib/utils"

interface SwitchProps extends React.HTMLAttributes<HTMLButtonElement> {
  checked?: boolean
  onCheckedChange?: (checked: boolean) => void
  disabled?: boolean
}

export function Switch({
  checked = false,
  onCheckedChange,
  disabled,
  className,
  ...props
}: SwitchProps) {
  const [internal, setInternal] = React.useState(!!checked)

  React.useEffect(() => {
    setInternal(!!checked)
  }, [checked])

  function toggle() {
    if (disabled) return
    const next = !internal
    setInternal(next)
    onCheckedChange?.(next)
  }

  return (
    <button
      type="button"
      role="switch"
      aria-checked={internal}
      aria-disabled={disabled || undefined}
      data-state={internal ? "checked" : "unchecked"}
      onClick={toggle}
      className={cn(
        "inline-flex h-6 w-11 items-center rounded-full border border-transparent transition-colors",
        internal ? "bg-primary" : "bg-muted",
        disabled && "opacity-50 cursor-not-allowed",
        className
      )}
      {...props}
    >
      <span
        className={cn(
          "pointer-events-none inline-block h-5 w-5 translate-x-0.5 rounded-full bg-white shadow transition-transform",
          internal && "translate-x-[22px]"
        )}
      />
    </button>
  )
}
